import { useState } from "react";
import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function AdsExpressItemFilterHelp({ isOfferMode }: { isOfferMode: boolean }) {
  const [open, setOpen] = useState(false);
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={`Why are some ${isOfferMode ? "offers" : "products"} hidden?`}
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
            data-testid="button-promoted-item-filter-help"
            onPointerDown={(event) => event.stopPropagation()}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              setOpen(true);
            }}
          >
            <HelpCircle className="h-3.5 w-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs" data-testid="text-promoted-item-filter-help-content">
          Only {isOfferMode ? "offers" : "products"} with a saved narrative angle for this persona are shown. Don&apos;t see one? Generate angles for it in Narrative Engine, or use a custom concept angle.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
